import React from 'react';
import cx from 'classnames';
import { Container } from 'react-bootstrap';

import campaignStyles from 'pages/storyboards/storyboardSettings/personalizationCampaign/components/AudienceSegment/audienceSegment.module.scss';

import styles from './personalization.module.scss';
import { SETS_PANEL_INTRO } from './filterSummaryClauses';

const Shimmer = ({ className, style }) => (
  <span className={cx(styles.shimmer, className)} style={style} aria-hidden="true" />
);

const FilterRowSkeleton = () => (
  <div className={styles.skeletonSegmentFilterRow}>
    <div className={styles.skeletonFilterPillsRow}>
      <Shimmer className={styles.skeletonFilterPillProperty} />
      <Shimmer className={styles.skeletonFilterPillCondition} />
    </div>
    <Shimmer className={styles.skeletonFilterValue} />
  </div>
);

const SetCardSkeleton = ({ expanded, nameWidth, showDelete }) => (
  <div className={styles.setCard}>
    <div
      className={cx(styles.setHeaderRow, {
        [styles.setHeaderRowExpanded]: expanded,
      })}
    >
      <div className={campaignStyles.detailTag}>
        <div
          className={cx(campaignStyles.actionWrapper, {
            [campaignStyles.active]: expanded,
          })}
        >
          <Shimmer className={styles.skeletonExpandBtn} />
        </div>
      </div>

      <div className={styles.setCollapsable}>
        <Shimmer className={styles.skeletonSetName} style={{ width: nameWidth }} />
      </div>

      {expanded && showDelete && <Shimmer className={styles.skeletonHeaderIcon} />}
    </div>

    {expanded && (
      <Container
        fluid
        className={cx(
          campaignStyles.contentFilterContainer,
          styles.setFilters,
          styles.contentGridSegmentFilters,
        )}
      >
        <FilterRowSkeleton />
        <Shimmer className={styles.skeletonAddFilterBtn} />
      </Container>
    )}
  </div>
);

/** Mirrors PersonalizationSetsPanel: set cards in setsList + footer primary button. */
export const PersonalizationSetsPanelSkeleton = () => (
  <aside
    className={cx(styles.setsPanel, styles.setsPanelLoading)}
    aria-busy="true"
    aria-label="Loading personalization sets"
  >
    <div className={styles.setsPanelIntro}>
      <p className={styles.setsPanelIntroText}>{SETS_PANEL_INTRO}</p>
      <div className={styles.setsPanelIntroSeparator} role="presentation" />
    </div>
    <div className={styles.setsList}>
      <SetCardSkeleton expanded nameWidth="5.5rem" showDelete />
      <SetCardSkeleton expanded={false} nameWidth="4.25rem" showDelete={false} />

      <div className={styles.setsPanelFooter}>
        <div className={cx(styles.newSetPrimaryBtn, styles.skeletonNewSetBtn)} aria-hidden>
          <Shimmer className={styles.skeletonNewSetIcon} />
          <Shimmer className={styles.skeletonNewSetLabel} />
        </div>
      </div>
    </div>
  </aside>
);
